const { VUE_APP_ISSUER, VUE_APP_CLIENT_ID, VUE_APP_REDIRECT_URI } = process.env

export default {
  oidc: {
    clientId: VUE_APP_CLIENT_ID,
    issuer: VUE_APP_ISSUER,
    redirectUri: VUE_APP_REDIRECT_URI,
    scopes: ['openid', 'profile', 'email'],
  },
}
